module.exports = __webpack_public_path__ + "static/media/login-header.8d6af3df.svg";